var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ImagesRepository_1;
import { IStorageDataSourceType } from '../../DataSource/StorageDataSource/IStorageDataSource';
import { IConfigurationRepositoryType } from '../../../Domain/UseCases/Configuration/IConfigurationRepository';
import { ImageCacheStrategyDTO } from '../../../Domain/DTOs/Application/ImageCacheStrategyDTO';
import { Observable } from '../../Observable/Observable';
import { getContentType, getExtension } from '../../../Helpers/ContentType/ContentType';
import { inject } from '../../Decorators/Inject';
import { injectable } from '../../Decorators/Injectable';
import * as FileSystem from 'expo-file-system';
import { Platform } from 'react-native';
let ImagesRepository = ImagesRepository_1 = class ImagesRepository {
    constructor(storageDataSource, configurationRepository) {
        this.storageDataSource = storageDataSource;
        this.configurationRepository = configurationRepository;
        this.processingImages = new Observable([]);
        this.images = [];
        this.cacheStrategy = new Observable(ImageCacheStrategyDTO.lazyLoad);
        const strategies = Object.values(ImageCacheStrategyDTO);
        this.configurationRepository.configuration.observe(this, configuration => {
            var _a, _b;
            const strategy = ((_b = (_a = configuration.application) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.image_cache_strategy) || ImageCacheStrategyDTO.lazyLoad;
            strategies.includes(strategy) && this.cacheStrategy.next(strategy);
        });
    }
    getLastImagesCheck() {
        return this.storageDataSource.get(ImagesRepository_1.imagesStorageCheckKey).then(val => (val || { value: null })).catch(() => ({ value: null }));
    }
    setLastImagesCheck(value) {
        return this.storageDataSource.set(ImagesRepository_1.imagesStorageCheckKey, { value }).catch(() => ({ value: null }));
    }
    getImageBlob(image) {
        var _a;
        return (_a = this.images.find(x => x.url === image)) === null || _a === void 0 ? void 0 : _a.blob;
    }
    getCacheStrategy() {
        return this.cacheStrategy;
    }
    getExpireTime() {
        var _a, _b;
        const value = (_b = (_a = this.configurationRepository.configuration.value.application) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.expire_images_time;
        if (typeof value !== 'number') {
            return 30 * 24 * 60;
        }
        return value;
    }
    getCachedImages() {
        if (Platform.OS === 'web') {
            return Promise.resolve(this.images);
        }
        return this.storageDataSource.get(ImagesRepository_1.imagesStorageKey)
            .then(data => data || [])
            .then((images) => __awaiter(this, void 0, void 0, function* () {
            const lastCheck = yield this.getLastImagesCheck();
            const expireTime = this.getExpireTime();
            const currentDate = Date.create().getTime() / 1000;
            if (lastCheck.value === null) {
                this.setLastImagesCheck(currentDate);
                return images;
            }
            if (lastCheck.value + expireTime > currentDate) {
                return images;
            }
            this.setLastImagesCheck(currentDate);
            return Promise.all(images.map((image) => {
                return FileSystem.getInfoAsync(image.uri)
                    .then(info => {
                    if (info.exists) {
                        if (info.modificationTime + expireTime < currentDate) {
                            return FileSystem.deleteAsync(image.uri)
                                .then(() => (Object.assign(Object.assign({}, image), { uri: undefined })))
                                .catch(() => (Object.assign(Object.assign({}, image), { uri: undefined })));
                        }
                        return image;
                    }
                    return Object.assign(Object.assign({}, image), { uri: undefined });
                })
                    .catch(() => (Object.assign(Object.assign({}, image), { uri: undefined })));
            }));
        }))
            .then(images => {
            images.forEach(image => {
                if (!image.uri) {
                    this.deleteImageFromStorage(image.url).catch(() => { });
                }
            });
            this.images = images.filter(x => x.uri);
            return this.images;
        });
    }
    getImageFile(url) {
        var _a;
        if (Platform.OS === 'web') {
            return url;
        }
        if (typeof url !== 'string') {
            return url;
        }
        if (url.startsWith('file:')) {
            return url;
        }
        return (_a = this.images.find(x => x.url === url)) === null || _a === void 0 ? void 0 : _a.uri;
    }
    getIsDownloading(url) {
        return this.processingImages.value.includes(url);
    }
    downloadImages(urls, options) {
        const images = urls.reduce((acc, image) => {
            if (!image || acc.includes(image)) {
                return acc;
            }
            acc.push(image);
            return acc;
        }, []);
        return Promise.all(images.map(url => this.downloadImage(url, options)));
    }
    loadFile(uri) {
        return getContentType(uri)
            .then(contentType => {
            return FileSystem.readAsStringAsync(uri, { encoding: 'base64' })
                .then(str => `data:${contentType};base64,${str}`);
        });
    }
    downloadImage(url, options) {
        if (Platform.OS === 'web') {
            return Promise.resolve(url);
        }
        if (!url) {
            return Promise.resolve(url);
        }
        if (typeof url === 'number') {
            return Promise.resolve(url);
        }
        if (url.startsWith('file:')) {
            return Promise.resolve(url);
        }
        if (Platform.OS === 'android' && (options === null || options === void 0 ? void 0 : options.preload)) {
            options.preload = false;
        }
        const loadedImage = this.images.find(x => x.url === url);
        const uri = this.getImageFile(url);
        if (uri === null || uri === void 0 ? void 0 : uri.endsWith('.html')) {
            return this.deleteImageFromStorage(url)
                .then(() => Promise.reject(new Error('Invalid mime type!')));
        }
        if (loadedImage) {
            if ((options === null || options === void 0 ? void 0 : options.preload) && !loadedImage.blob) {
                return this.loadFile(loadedImage.uri)
                    .then(file => {
                    loadedImage.blob = file;
                    return loadedImage.uri;
                })
                    .catch(error => {
                    console.warn(error);
                    return loadedImage.uri;
                });
            }
            return Promise.resolve(uri);
        }
        if (this.getIsDownloading(url)) {
            return new Promise((res, rej) => {
                const sub = this.processingImages.subscribe(images => {
                    if (!images.includes(url)) {
                        if (!this.getImageFile(url)) {
                            rej(new Error('Unsuccessful downloading. Unkown reason!'));
                            sub.unsubscribe();
                            return;
                        }
                        res(this.getImageFile(url));
                        sub.unsubscribe();
                    }
                });
            });
        }
        this.addProcessingImage(url);
        return this.getFileURI(url)
            .then(uri => {
            const downloadResumable = FileSystem.createDownloadResumable(url, uri);
            return downloadResumable.downloadAsync()
                .then(value => {
                if (!(value === null || value === void 0 ? void 0 : value.uri)) {
                    return Promise.reject(new Error('Unable to save file!'));
                }
                return value.uri;
            })
                .then(uri => this.addImageToStorage(url, uri))
                .then(image => {
                if (options === null || options === void 0 ? void 0 : options.preload) {
                    return this.loadFile(image.uri)
                        .then(file => {
                        image.blob = file;
                        return image;
                    })
                        .catch(error => {
                        console.warn(error);
                        return image;
                    });
                }
                return image;
            })
                .then(image => {
                this.images.push(image);
                this.removeProcessingImage(image.url);
                return image.uri;
            });
        })
            .catch(error => {
            this.removeProcessingImage(url);
            return Promise.reject(error);
        });
    }
    addImageToStorage(url, uri) {
        this.images.push({ url, uri });
        return this.storageDataSource.set(ImagesRepository_1.imagesStorageKey, this.images.map(image => (Object.assign(Object.assign({}, image), { blob: undefined })))).then(() => ({ url, uri }));
    }
    getFileURI(url) {
        return getContentType(url)
            .then(contentType => {
            let extention = getExtension(contentType);
            if (!extention || extention === 'html') {
                return Promise.reject(new Error('Invalid mime type!'));
            }
            return `${FileSystem.cacheDirectory}cached-image-${this.getImageUUID()}.${extention}`;
        });
    }
    removeProcessingImage(url) {
        return this.processingImages.next(this.processingImages.value.filter(x => x !== url));
    }
    addProcessingImage(url) {
        return this.processingImages.next([...this.processingImages.value, url]);
    }
    deleteImageFromStorage(url) {
        this.images = this.images.filter(x => x.url !== url);
        return this.storageDataSource.set(ImagesRepository_1.imagesStorageKey, this.images);
    }
    getImageUUID() {
        return 'xxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = Math.random() * 16 | 0;
            const v = c == 'x'
                ? r
                : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
};
ImagesRepository.imagesStorageKey = 'cached_images_animated_image';
ImagesRepository.imagesStorageCheckKey = 'cached_images_check';
ImagesRepository = ImagesRepository_1 = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(IStorageDataSourceType)),
    __param(1, inject(IConfigurationRepositoryType)),
    __metadata("design:paramtypes", [Object, Object])
], ImagesRepository);
export { ImagesRepository };
